import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Grid, TextField, InputAdornment, Tooltip, Fab, FormControl, Divider, FormControlLabel, RadioGroup, Radio, Typography } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import { SelecionarData } from 'components'
import useStyles from './FormCadaver.styles'

export const FormCadaver = (props) => {
  const { cadaverForm } = props
  const [arrayFiliacao, setArrayFiliacao] = useState(['filiacao0', 'filiacao1'])
  const classes = useStyles()

  const handleAdicionarFiliacao = () => {
    const newInput = `filiacao${arrayFiliacao.length}`
    const array = arrayFiliacao.concat([newInput])
    setArrayFiliacao(array)
  }

  const setDataColeta = (data) => {
    cadaverForm.handleChangeCampoData('dataNascimento', data)
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        {/* Nome Completo */}
        <Grid item md={8} sm={8} xs={12}>
          <TextField
            fullWidth
            required
            label="NOME COMPLETO"
            name="nome"
            onChange={cadaverForm.handleChange}
            value={cadaverForm.formState.values.nome || ''}
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

        <Grid item md={4} sm={4} xs={12}>
          <Grid item xs={12}>
            <Typography variant="body2">SEXO</Typography>
          </Grid>
          <FormControl component="fieldset" fullWidth>
            <RadioGroup
              label="SEXO"
              name="sexo"
              value={cadaverForm.formState.values.sexo || 'DESCONHECIDO'}
              onChange={cadaverForm.handleChange}
              style={{ display: 'flex', flexDirection: 'row' }}
            >
              <FormControlLabel value="MASCULINO" control={<Radio />} label={<Typography variant="body2">MASCULINO</Typography>} />
              <FormControlLabel value="FEMININO" control={<Radio />} label={<Typography variant="body2">FEMININO</Typography>} />
              <FormControlLabel value="DESCONHECIDO" control={<Radio />} label={<Typography variant="body2">DESCONHECIDO</Typography>} />
            </RadioGroup>
          </FormControl>
        </Grid>

        {/* Filiações alinhadas diretamente no grid principal */}
        {arrayFiliacao.map((input, index) => (
          <Grid item md={8} sm={8} xs={12} key={input}>
            <TextField
              error={cadaverForm.hasError(input)}
              fullWidth
              helperText={
                cadaverForm.hasError(input)
                  ? cadaverForm.formState.errors[input][0]
                  : null
              }
              label={`FILIAÇÃO (${index + 1})`}
              name={input}
              onChange={cadaverForm.handleChange}
              value={cadaverForm.formState.values[input] || ''}
              InputProps={{
                endAdornment: index + 1 === arrayFiliacao.length && (
                  <InputAdornment position="end">
                    <Tooltip title="Adicionar filiação">
                      <Fab
                        color="primary"
                        size="small"
                        onClick={handleAdicionarFiliacao}
                      >
                        <AddIcon />
                      </Fab>
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        ))}

        {/* Naturalidade */}
        <Grid item md={8} sm={8} xs={12}>
          <TextField
            fullWidth
            label="NATURALIDADE"
            name="naturalidade"
            onChange={cadaverForm.handleChange}
            value={cadaverForm.formState.values.naturalidade || ''}
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

        {/* Data de Nascimento */}
        <Grid item md={4} sm={12} xs={12}>
          <FormControl style={{ minWidth: '100%', maxWidth: '100%' }}>
            <SelecionarData
              dataBD={cadaverForm.formState.values.dataNascimento}
              withoutTime
              name="dataNascimento"
              callback={setDataColeta}
              label="DATA DE NASCIMENTO"
              xs={12}
              sm={12}
              md={12}
            />
          </FormControl>
        </Grid>
      </Grid>


    </div>
  )
}

FormCadaver.propTypes = {
  cadaver: PropTypes.object,
  cadaverForm: PropTypes.object.isRequired,
}
